import { render, staticRenderFns } from "./alertModal.vue?vue&type=template&id=35f6def5&"
import script from "./alertModal.vue?vue&type=script&lang=js&"
export * from "./alertModal.vue?vue&type=script&lang=js&"
import style0 from "./alertModal.vue?vue&type=style&index=0&id=35f6def5&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f6def5')) {
      api.createRecord('35f6def5', component.options)
    } else {
      api.reload('35f6def5', component.options)
    }
    module.hot.accept("./alertModal.vue?vue&type=template&id=35f6def5&", function () {
      api.rerender('35f6def5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/alertModal.vue"
export default component.exports